import { useAuth0 } from "@auth0/auth0-react";

/**
 * The React read-side of auth. auth0-react's reducer is the canonical source of
 * `isAuthenticated`/`isLoading`/`user`; the ky hooks read the separate
 * `authState` module for the latch and terminal states they need outside React.
 */
export const useAuth = () => {
  const { isAuthenticated, isLoading, user } = useAuth0();
  return { isAuthenticated, isLoading, user };
};
